import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from '@commons/tooltip/tooltip.component';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { CompaniesRoutingEnum } from '@features/companies/companies-routing.enum';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home-b-employer-engagement',
  templateUrl: './home-b-employer-engagement.component.html',
  styleUrls: ['./home-b-employer-engagement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBEmployerEngagementComponent {
  trackEvent = trackEventWithAtInternet;
  FeaturesRoutingEnum = FeaturesRoutingEnum;
  CompaniesRoutingEnum = CompaniesRoutingEnum;

  illustrationSrc = `${environment.wizbiiImages}/homeB/hero/orange.jpg`;

  get isMobileOrTablet$(): Observable<boolean> {
    return this.breakpointsService.isMobileOrTablet$;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}
}

@NgModule({
  imports: [CommonModule, RouterModule, TooltipModule, ImaginarySrcModule],
  declarations: [HomeBEmployerEngagementComponent],
  exports: [HomeBEmployerEngagementComponent],
})
export class HomeBEmployerEngagementModule {}
